'use strict'

define ['./company.scss'], () ->
  ($scope, $http, RentappService, RENTAPPLICATION_API_URL, $state, Flash, $uibModal, $window, $cacheFactory) ->
    $scope.mobile_view = window.innerWidth < 768
    $scope.load_companies = ->
      $scope.loading_companies = true;
      $http.get "#{RENTAPPLICATION_API_URL}/api/v2/company/"
      .then (resp) ->
        $scope.companies = resp.data.results
        $scope.memberships = _.flatten(resp.data.results.map (company)->
          company.memberships.map (membership) ->
            membership.company = company
            membership
        )
      .finally ->
        $scope.loading_companies = false;
    
    if not $scope.mobile_view
      $scope.load_companies()
    else
      Flash.create('warning', 'Please use in desktop mode to access the company admin page.', 0)

    $scope.open_add_user_modal = (company) ->
      $scope.current_company = angular.copy(company)

      $uibModal.open
        scope: $scope
        template: require("./userAddModal/userAddModal.jade")
        controller: require("./userAddModal/userAddModal.coffee")
        windowClass: 'user-add-modal'
      .result.then () ->
        $scope.current_company = null
        $scope.load_companies()

    $scope.toggle_user = (membership)->
      if membership
        $scope.current_membership = angular.copy(membership)
      else
        $scope.current_membership = null
      $scope.user_toggled = !$scope.user_toggled

    $scope.open_remove_user_modal = ->
      $uibModal.open
        scope: $scope
        template: require("./userDeleteModal/userDeleteModal.jade")
        controller: require("./userDeleteModal/userDeleteModal.coffee")
        windowClass: 'user-delete-modal'
      .result.then () ->
        $scope.toggle_user()
        $scope.load_companies()

    $scope.patch_membership = ->
      $http.patch "#{RENTAPPLICATION_API_URL}/api/v1/companymembership/#{$scope.current_membership.id}/",
        can_admin: $scope.current_membership.can_admin
        is_agent: $scope.current_membership.is_agent
        can_create: $scope.current_membership.can_create
        show_accept_reject_button: $scope.current_membership.landlord.show_accept_reject_button
        show_my_payments: $scope.current_membership.landlord.show_my_payments
      .then (response) ->
        Flash.create('success', $scope.current_membership.user.username + ' saved.', 3000, {class: 'profile-success'}, true)
        $cacheFactory.get("$http").removeAll()
        $scope.load_companies()
      .catch (response) ->
        if response.status == 401
          Flash.create('danger', "Sorry, you don't have permission to edit this user.", 3000, { class: 'error' }, true)
      .finally ->
        $scope.toggle_user()



// WEBPACK FOOTER //
// ./components/dashboard/settings/company/company.coffee